import * as React from "react";
import { Drawer, List, ListItem, Menu, MenuItem, styled } from "@mui/material";
import { useCallback } from "react";
import { PopoverProps } from "@mui/material/Popover";
import { useScreenSize } from "../util/useScreenSize";

//region [[ Styles ]]

const DiseaseItemMenuDrawer = styled(Drawer)({});

const DiseaseItemMenuPopper = styled(Menu)({});

const MobileDrawerList = styled(List)({});

const MobileDrawerItem = styled(ListItem)({
  fontSize: "1rem",
});

//endregion [[ Styles ]]

//region [[ Props ]]
interface MenuAction {
  text: string;
  action: (props: any) => void;
  disabled?: boolean;
}

export interface MobileSupportedContextMenuProps {
  className?: string;
  id?: string;
  open: boolean;
  anchorEl?: PopoverProps["anchorEl"];
  onClose: () => void;
  actions: MenuAction[];
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const MobileSupportedContextMenu = ({
  onClose,
  ...props
}: MobileSupportedContextMenuProps) => {
  const { isMobile } = useScreenSize();

  const actionHandler = useCallback(
    (action) => (e) => {
      if (onClose) onClose();
      action(e);
    },
    [onClose],
  );

  // Desktop:
  if (!isMobile)
    return (
      <DiseaseItemMenuPopper
        className={props.className}
        anchorEl={props.anchorEl}
        open={props.open}
        onClose={onClose}
        id={props.id}
      >
        {props.actions.map((menuItem, idx) => (
          <MenuItem
            key={idx}
            onClick={actionHandler(menuItem.action)}
            disabled={menuItem.disabled}
          >
            {menuItem.text}
          </MenuItem>
        ))}
      </DiseaseItemMenuPopper>
    );

  // Mobile:
  return (
    <DiseaseItemMenuDrawer
      className={props.className}
      anchor={"bottom"}
      open={props.open}
      onClose={onClose}
      id={props.id}
    >
      <MobileDrawerList>
        {props.actions.map((menuItem, idx) => (
          <MobileDrawerItem key={idx} onClick={actionHandler(menuItem.action)}>
            {menuItem.text}
          </MobileDrawerItem>
        ))}
      </MobileDrawerList>
    </DiseaseItemMenuDrawer>
  );
};
